import { createSelector } from 'reselect';

const selectApp = state => state.app;

export const selectDimensions = createSelector(selectApp, app => app.dimensions);
export const selectOnline = createSelector(selectApp, app => app.online);
export const selectMessages = createSelector(selectApp, app => app.messages);
export const selectNavbarVisible = createSelector(selectApp, app => app.navbarVisible);
